import { DefectsState } from '.';

export const selectDefects = (state: { defects: DefectsState }) => state.defects.defects;
export const selectGetDefectsStatus = (state: { defects: DefectsState }) => state.defects.getDefectsStatus;
export const selectGetDefectsError = (state: { defects: DefectsState }) => state.defects.getDefectsError;
export const selectDefectsCount = (state: { defects: DefectsState }) => state.defects.defectsCount;

export const selectDeleteDefectsStatus = (state: { defects: DefectsState }) => state.defects.deleteDefectsStatus;
export const selectDeleteDefectsError = (state: { defects: DefectsState }) => state.defects.deleteDefectsError;

export const selectCloseDefectsStatus = (state: { defects: DefectsState }) => state.defects.closeDefectsStatus;
export const selectCloseDefectsError = (state: { defects: DefectsState }) => state.defects.closeDefectsError;

export const selectAddDefectStatus = (state: { defects: DefectsState }) => state.defects.addDefectStatus;
export const selectAddDefectError = (state: { defects: DefectsState }) => state.defects.addDefectError;

export const selectGetDefectStatus = (state: { defects: DefectsState }) => state.defects.getDefectStatus;
export const selectGetDefectError = (state: { defects: DefectsState }) => state.defects.getDefectError;
export const selectDefect = (state: { defects: DefectsState }) => state.defects?.defect;

export const selectEditDefectStatus = (state: { defects: DefectsState }) => state.defects.editDefectStatus;
export const selectEditDefectError = (state: { defects: DefectsState }) => state.defects.editDefectError;

export const selectDeleteDefectStatus = (state: { defects: DefectsState }) => state.defects.deleteDefectStatus;
export const selectDeleteDefectError = (state: { defects: DefectsState }) => state.defects.deleteDefectError;

export const selectDefectsForSelector = (state: { defects: DefectsState }) => state.defects.defectsForSelector;
export const selectDefectsForSelectorCount = (state: { defects: DefectsState }) =>
    state.defects.defectsForSelectorCount;
export const selectGetDefectsForSelectorStatus = (state: { defects: DefectsState }) =>
    state.defects.getDefectsForSelectorStatus;
export const selectGetDefectsForSelectorError = (state: { defects: DefectsState }) =>
    state.defects.getDefectsForSelectorError;

export const selectJiraIssues = (state: { defects: DefectsState }) => state.defects.jiraIssues;
export const selectJiraIssuesCount = (state: { defects: DefectsState }) => state.defects.jiraIssuesCount;
export const selectGetJiraIssuesStatus = (state: { defects: DefectsState }) => state.defects.getJiraIssuesStatus;
export const selectGetJiraIssuesError = (state: { defects: DefectsState }) => state.defects.getJiraIssuesError;

export const selectCreatedDefect = (state: { defects: DefectsState }) => state.defects.createdDefect;
